import { buildTeamDiscordProfileUrl, buildTeamSocialProfileUrl, } from "../team.js";
function getTeamMemberSameAs(member) {
    const urls = [];
    if (member.discord.userId)
        urls.push(buildTeamDiscordProfileUrl(member.discord.userId));
    for (const platform of ["linkedin", "github", "npm"]) {
        const social = member.socials[platform];
        if (social)
            urls.push(buildTeamSocialProfileUrl(platform, social.handle));
    }
    if (member.socials.portfolio)
        urls.push(member.socials.portfolio.url);
    return urls;
}
export function createLogscordTeamStructuredData(canonical, siteUrl, locale, description, team) {
    return [
        {
            type: "application/ld+json",
            json: {
                "@context": "https://schema.org",
                "@type": "AboutPage",
                url: canonical,
                name: "LogsCord",
                description,
                mainEntity: {
                    "@type": "Organization",
                    "@id": `${siteUrl.replace(/\/$/, "")}/#organization`,
                    name: "LogsCord",
                    url: `${siteUrl.replace(/\/$/, "")}/`,
                    member: team.members.map((member) => ({
                        "@type": "Person",
                        "@id": `${canonical}#${member.id}`,
                        name: member.discord.displayName,
                        jobTitle: member.copy[locale].role,
                        image: member.discord.avatarUrl ?? undefined,
                        sameAs: getTeamMemberSameAs(member),
                    })),
                },
            },
        },
    ];
}
//# sourceMappingURL=team.js.map